var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MonthSelector',{on:{"select":_vm.load}}),_c('List',{staticClass:"my-3",attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }